import extendNode from '../extendNode.mjs'
import Color from '../Color.mjs'
import useArchNode from '../_ARCH/useArchNode.jsx'
import meta from './metaPa.mjs'
import PropertiesPane from './PropertiesPanePa.jsx'
import api from './apiPa.mjs'

export default () => {
    const ArchNode = useArchNode()

    return extendNode(ArchNode, {
        ...meta,
        api,
        PropertiesPane,

        getStyle(map, node) {
            const {subTypeCode} = map.data

            const backgroundColor = 'BODA1' === subTypeCode ?
                Color.GOLD : Color.LIGHT_YELLOW

            return this._getStyle(map, node, {backgroundColor})
        },

        _pushDataSlots: {
            archPmList: [],
        },
    })
}
